export const DISPOSAL_LOADING = "DISPOSAL_LOADING";
export const DISPOSAL_RESET = "DISPOSAL_RESET";
export const GET_DISPOSAL = "GET_DISPOSAL";
export const GET_DISPOSAL_SUCCESS = "GET_DISPOSAL_SUCCESS";
export const GET_DISPOSAL_FAIL = "GET_DISPOSAL_FAIL";
export const DELETE_DISPOSAL = "DELETE_DISPOSAL"
export const DELETE_DISPOSAL_SUCCESS = "DELETE_DISPOSAL_SUCCESS"
export const DELETE_DISPOSAL_FAIL = "DELETE_DISPOSAL_FAIL"
export const UPDATE_DISPOSAL = "UPDATE_DISPOSAL"
export const UPDATE_DISPOSAL_SUCCESS = "UPDATE_DISPOSAL_SUCCESS"
export const UPDATE_DISPOSAL_FAIL = "UPDATE_DISPOSAL_FAIL"
export const ADD_NEW_DISPOSAL = "ADD_NEW_DISPOSAL"
export const ADD_DISPOSAL_SUCCESS = "ADD_DISPOSAL_SUCCESS"
export const ADD_DISPOSAL_FAIL = "ADD_DISPOSAL_FAIL"
export const DISPOSAL_RESET_CREATE = "DISPOSAL_RESET_CREATE"